import styled from "styled-components";


export const PageStyle = styled.div`
  
    
    .topbar{
      display: flex;
      align-items: center;
      padding-bottom: 15px;
    }
  
    .loading{
      padding:30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

  table.data{
    width: 100%;
    border:1px solid #dedede;
    background: #fff;
    border-radius: 5px;
    
    th,td{
      padding:12px 10px;
      border-bottom:1px solid #dedede;
      text-align: center;
      font-size:13px;
    }
    
    .text-center{
      text-align: center;
    }
    .text-left{
      text-align: left;
    }
    .text-right{
      text-align: right;
    }
    
    .value{
      font-size:13px;
    }
    
  }
  
    
    
`;
